import { cn } from '../lib/cn.js';

export type ProviderName = 'google' | 'apple';

export interface ProviderIconProps {
  provider: ProviderName;
  className?: string;
}

export function ProviderIcon({ provider, className }: ProviderIconProps) {
  if (provider === 'google') {
    return (
      <svg viewBox="0 0 24 24" aria-hidden className={cn('h-5 w-5 shrink-0', className)}>
        <path
          d="M21.6 12.227c0-.708-.064-1.39-.182-2.045H12v3.868h5.382c-.232 1.252-.937 2.313-1.997 3.022v2.51h3.232c1.892-1.742 2.983-4.31 2.983-7.355z"
          fill="#4285F4"
        />
        <path
          d="M12 22c2.7 0 4.964-.895 6.617-2.418l-3.232-2.51c-.895.6-2.04.955-3.385.955-2.604 0-4.81-1.76-5.596-4.123H3.064v2.59A9.997 9.997 0 0 0 12 22z"
          fill="#34A853"
        />
        <path
          d="M6.404 13.904a6.01 6.01 0 0 1 0-3.808V7.506H3.064a9.997 9.997 0 0 0 0 8.988l3.34-2.59z"
          fill="#FBBC05"
        />
        <path
          d="M12 5.973c1.468 0 2.786.505 3.823 1.495l2.868-2.868C16.96 2.99 14.696 2 12 2 8.097 2 4.726 4.24 3.064 7.506l3.34 2.59C7.19 7.733 9.396 5.973 12 5.973z"
          fill="#EA4335"
        />
      </svg>
    );
  }

  // Apple: monochrome glyph, inherits currentColor so it adapts to theme.
  return (
    <svg
      viewBox="0 0 24 24"
      aria-hidden
      className={cn('h-5 w-5 shrink-0', className)}
      fill="currentColor"
    >
      <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z" />
    </svg>
  );
}
